<template>
  <footer class="gameplay">
    <section>
      <slot></slot>
    </section>
  </footer>
</template>
